<template>
  <base-modal ref="modal">
    <base-card shadow>
      <h3 class="tw-text-xl tw-font-thin">Refund</h3>
      <base-form ref="form" v-model="isFormValid">
        <base-currency-input
          label="Amount to Refund"
          placeholder="Enter amount to refund"
          :int-value.sync="amountToRefundInt"
          v-model="amountToRefund"
          required
          class="tw-mt-3"
          :rules="amountRules"
        />
        <base-select v-model="selectedReason" label="Reason" placeholder="Please choose a reason for the refund" :options="reasonOptions" required />
      </base-form>
      <div class="sm:tw-flex sm:tw-flex-row-reverse tw-mt-1">
        <base-button @click="refund" :loading="isLoading" :disabled="!isFormValid" class="tw-w-full sm:tw-w-auto sm:tw-ml-3">Refund</base-button>
        <base-button @click="hide" type="flat" class="tw-w-full sm:tw-w-auto tw-mt-2 sm:tw-mt-0">
          Cancel
        </base-button>
      </div>
    </base-card>
  </base-modal>
</template>

<script>
export default {
  props: {
    businessId: String,
    userId: String,
  },
  data() {
    return {
      isFormValid: true,
      isLoading: false,
      amountToRefund: null,
      amountToRefundInt: null,
      selectedReason: null,
      charge: {},
      reasonOptions: [{ value: "duplicate", label: "Duplicate" }, { value: "fraudulent", label: "Fraudulent" }, { value: "requested_by_customer", label: "Requested by customer" }],
    };
  },
  computed: {
    refundMax() {
      return this.charge.amount - this.charge.amountRefunded;
    },
    amountRules() {
      return [
        () => this.amountToRefundInt <= this.refundMax || `Must be less than $${(this.refundMax / 100).toFixed(2)}`,
        () => this.amountToRefundInt >= 0.01 || "Must be greater than $0.01",
      ];
    },
  },
  methods: {
    show(charge) {
      this.$refs.form.reset();
      this.charge = charge;
      this.amountToRefund = charge.amount - charge.amountRefunded;
      this.$refs.modal.show();
    },
    hide() {
      this.$refs.modal.hide();
    },
    async refund() {
      if (!this.$refs.form.validate()) return;
      try {
        this.isLoading = true;
        await this.$axios.post(`/businesses/${this.businessId}/members/${this.userId}/payments/refund/${this.charge.eventId}`, {
          amount: this.amountToRefundInt,
          reason: this.selectedReason,
        });
        this.$emit("refresh");
        this.hide();
      } catch (error) {
        this.EventBus.$emit("GLOBAL_ERROR", {
          title: "Failed to give refund",
          message: "We had a problem giving a refund to this user. Please reload the page to try again.",
          error,
        });
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>
